<template>
    <div class="home-content">
        <MainContent />
    </div>
</template>

<script>
import MainContent from '@/components/MainContent/index.vue'

export default {
    components:{
        MainContent
    }
        
    
}
</script>

<style type="text/css">
    /* .home-content{
        height: 90vh;
        width: 96vw;        
        position: fixed;
        top: 10vh;
        left: 5em;
        z-index: 2;
        border-radius: 60px 0 0 0;
    } */

</style>